// @ts-check
import { VoyageTooltipManager } from './voyage-tooltip-manager';
import { customElement} from 'lit/decorators.js';
import { LitElement } from 'lit';

// Simple element that creates a (text-only) tooltip for the parent element using VoyageTooltipManager
export class VoyageTooltipProxy extends LitElement
{
    constructor()
    {
        super();
        
        this.text = "";
        this.positionPriority = ["top", "right", "left", "bottom"];
        this.htmlContent = false;
        this.tooltipInteraction = false;
        this._actualTooltip = null;
        this.innerComponent = null;
    }

    static get properties()
    {
        return {
            text: { type: String },
            positionPriority: { type: Array, attribute: "position-priority" },
            htmlContent: { type: Boolean, attribute: "html-content" },
            tooltipInteraction: { type: Boolean, attribute: "tooltip-interaction" },
            innerComponent: {type: HTMLElement }
        }
    }

    updated(changedProperties)
    {
        if (this._actualTooltip)
        {
            changedProperties.forEach( (oldValue, propName) => {
                if (propName === "text")
                {
                    if (this.htmlContent)
                    {
                        this._actualTooltip.innerHTML = this.text;
                    }
                    else
                    {
                        this._actualTooltip.textContent = this.text;
                    }
                } else if (propName === "innerComponent"){
                   this._actualTooltip.innerComponent = this.innerComponent
                }
                else
                {
                    this._actualTooltip.positionPriority = this.positionPriority;
                }
            });    
        }
    }

    connectedCallback()
    {
        super.connectedCallback();
        this._actualTooltip = VoyageTooltipManager.createTooltip(this, this.parentElement, this.text, {
            positionPriority: this.positionPriority,
            htmlContent: this.htmlContent,
            tooltipInteraction: this.tooltipInteraction
        });
    }

    disconnectedCallback()
    {
        super.disconnectedCallback();
        VoyageTooltipManager.removeTooltips(this);
    }
};

customElements.define('voyage-tooltip-proxy', VoyageTooltipProxy);
